module.exports = __webpack_public_path__ + "img/june-green.41f957ff.svg";